import type { IScreensLogging } from '../../../../../api/types';
import { bridge } from '../../../../../utils';

// iOS MetaFeedOutfitCell: CLICK_BOOKMARK (북마크 버튼 탭 시)
export const logOnPressBookmark = ({
  logging,
  nextBookmarked,
}: {
  logging: IScreensLogging;
  nextBookmarked: boolean;
}) => {
  bridge.logAnalyticsEvent({
    name: 'CLICK_BOOKMARK',
    analytics: {
      ...logging.analytics,
      STATUS: nextBookmarked,
    },
    ably_only_log: logging.ably_only_log,
  });
};